import { createContext, useCallback, useMemo, useState } from 'react';

type TableHistoryContextType = {
  isOpen: boolean;
  history?: any[];
  toggle: () => void;
  setIsOpen: (flag: boolean) => void;
};

export const TableHistoryContext = createContext<TableHistoryContextType>({
  isOpen: false,
  history: [],
  toggle: () => {},
  setIsOpen: (_: boolean) => {}
});

export const TableHistoryProvider = ({ children }: any) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = useCallback(() => {
    setIsOpen((prevState) => !prevState);
  }, []);

  // PERF: memoized so consumers only re-render when one of these values
  // actually changes, not on every provider re-render. See
  // docs/investigations/20260819-game-client-overheating.md.
  const value = useMemo(() => ({ isOpen, setIsOpen, toggle }), [isOpen, toggle]);

  return <TableHistoryContext.Provider value={value}>{children}</TableHistoryContext.Provider>;
};

export default TableHistoryContext;
